import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Header, Icon, Message } from 'semantic-ui-react';
import QrReader from 'react-qr-reader';
import { useNavigate } from 'react-router-dom';
import agent from '../../../app/api/agent';
import './styles.css';
import { useStore } from '../../../app/stores/store';
import UnauthorizedMessage from '../../UnauthorizedMessage';

function AssignUserScan() {
  const { dashboardStore, commonStore } = useStore();
  const history = useNavigate();

  const [, setIsSearching] = useState(false);
  const [error, setError] = useState({
    camera: false,
    message: '',
  });

  useEffect(() => {
    let timer = setTimeout(() => {
      setError({
        ...error,
        message: '',
      });
    }, 3000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [error.message]);

  const handleError = () => {
    setError({
      ...error,
      camera: true,
      message: '',
    });
  };

  const handleScan = async (data: string | null) => {
    if (data) {
      setIsSearching(true);
      const result = await agent.Activities.scanUser({ scanUserId: data });

      if (result?.data?.length === 0) {
        setError({
          ...error,
          camera: false,
          message: "Sorry! We can't find the scanned user",
        });
        setIsSearching(false);
        return;
      }

      history(`asset_details/${data}`);
      setIsSearching(false);
    }
  };

  return (
    <>
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('MRAU01') && (
          <UnauthorizedMessage />
        )}
      {commonStore.filterModeOne.includes('MRAU01') && (
        <div className="assign-user-scan-wrapper">
          <Header as="h3">
            <Icon name="user" size="tiny" />
            <Header.Content>Scan User</Header.Content>
          </Header>
          {error.camera ? (
            <Message
              negative
              content="We're sorry we can't scan the user without accessing the camera."
            />
          ) : (
            <>
              <Message
                info
                content="Please scan the user to whom the item will be handover"
              />
              <QrReader
                delay={300}
                onError={handleError}
                onScan={handleScan}
                style={{ width: '100%' }}
                facingMode="environment"
              />
            </>
          )}
          {error.message && (
            <Message negative content={error.message}></Message>
          )}
          {/* {isSearching && (
     <Message icon>
       <Icon name="circle notched" loading />
       <Message.Content>
         We are fetching that content for you.
       </Message.Content>
     </Message>
   )} */}
        </div>
      )}
    </>
  );
}

export default observer(AssignUserScan);
